import { render, staticRenderFns } from "./PartnerInvoiceTable.vue?vue&type=template&id=35d51fa4&scoped=true&"
import script from "./PartnerInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./PartnerInvoiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d51fa4",
  null
  
)

export default component.exports